import { render, staticRenderFns } from "./ServiceIconWrapper.vue?vue&type=template&id=6f5a5b0f&scoped=true&"
import script from "./ServiceIconWrapper.vue?vue&type=script&lang=js&"
export * from "./ServiceIconWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a5b0f",
  null
  
)

export default component.exports